import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import {
	BOX_SERIES_TYPE,
	BOXTYPE,
	PUBLISHED_LISTB,
} from '@/common/constants/common';
import { BoxFilter } from '@/api/DTO/exchange/box.interface';

export default function MysteryBoxSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<BoxFilter>();

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid item xs={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='boxTypeList'
					label={t('box.boxType')}
					options={BOXTYPE}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='gameTypeList'
					label={t('box.seriesType')}
					options={BOX_SERIES_TYPE}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
			<Grid item xs={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='publishedList'
					label={t('box.boxStatus')}
					options={PUBLISHED_LISTB}
					size='small'
					emptyArrayIfNoSelection
				/>
			</Grid>
		</Grid>
	);
}
